import {
  AI_MODEL,
  AI_MODEL_MODE,
  AI_MODE_PROMPT,
  ARK_V3_MODEL_ID,
  ModelSourceType,
  TTS_CLUSTER,
  VOICE_TYPE,
} from './config';

export const AIGC_PROXY_HOST = 'https://cybersay.mossyu.com';
//export const AIGC_PROXY_HOST = 'http://localhost:8080';

/**
 * @brief Defining RTC & AIGC config
 * @notes If you wanna get full config and description of params, refer to https://api.volcengine.com/api-explorer?action=StartVoiceChat&groupName=%E6%99%BA%E8%83%BD%E4%BD%93&serviceCode=rtc&version=2024-06-01
 */
export class Config {

  //流式语音识别相关配置
  //RTC的appid
  //AppId = '676f5e8d0eb6200103a9d453';
  AppId = '6791a703c1cde501dd2eb16c';

  ASRConfig = {
    //AppId: '8140809498',
    AppId: '8974420009',
  };

  TTSConfig = {
    //AppId: '8140809498',
    AppId: '8974420009',
    Cluster: TTS_CLUSTER.TTS,
    //VoiceType: VOICE_TYPE.炀炀,
    VoiceType: "BV701_streaming",
  };

  LLMConfig = {
    Mode: AI_MODEL_MODE.ARK_V3,
    //BotId: 'bot-20241228103948-xwl6f',
    BotId: 'bot-20250216090647-dfvdr',
    SystemMessages: [AI_MODE_PROMPT[AI_MODEL.DOUBAO_PRO_256K]],
    ModelName: AI_MODEL.DOUBAO_PRO_256K,
    ModelVersion: '1.0',
    WelcomeSpeech: '你好，欢迎来到我的咨询室。我是儒家哲学咨询智能体 — 赛博子曰，我精通孔子哲学思想，擅长帮助人们解决思想和观念上的困惑。我的方法是通过引导深入哲学思考，帮助你找到自己的答案。',
    ModeSourceType: ModelSourceType.Available,
    //APIKey: '6069626a-8844-4e44-8a7c-30b06d219b9c',
    APIKey: 'ef3ee9e2-38e8-4336-a327-7cc29baa0bf3',
    Url: 'https://ark.cn-beijing.volces.com/api/v3',
    Feature: JSON.stringify({ Http: true }),
  };

  //默认值为voiceChat_$(UserId)_$(timestamp_now)
  BotName = 'RTCBotTest';

  getAIGCConfig() {
    return {
      AppId: this.AppId,
      Config: {
        BotName: this.BotName,
        LLMConfig: this.LLMConfig,
        TTSConfig: this.TTSConfig,
        ASRConfig: this.ASRConfig,
      },
    };
  }
}

const config = new Config();

export * from './config';
export default config;
